"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFX = void 0;
var RFX;
(function (RFX) {
    RFX["RFP"] = "RFP";
    RFX["RFQ"] = "RFQ";
    RFX["TENDER"] = "TENDER";
})(RFX = exports.RFX || (exports.RFX = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmZ4LmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2VudW1zL3JmeC5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksR0FJWDtBQUpELFdBQVksR0FBRztJQUNiLGtCQUFXLENBQUE7SUFDWCxrQkFBVyxDQUFBO0lBQ1gsd0JBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUpXLEdBQUcsR0FBSCxXQUFHLEtBQUgsV0FBRyxRQUlkIn0=